// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-2nlGAj","copy":"copy-1Jh7Nx","copySecondary":"copySecondary-3V56u7","image":"image-22JIE5"};